import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from './auth/AuthContext';
import './Navbar.css';

function Navbar() {
  const { user, isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  const isChatPage = location.pathname === '/chat';

  /* 🔁 Track screen resize */
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);

      // Close menu automatically when switching to desktop
      if (!mobile) {
        setMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  /* 🔒 Prevent background scroll when menu is open (mobile UX polish) */
  useEffect(() => {
    if (menuOpen && isMobile) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }, [menuOpen, isMobile]);

  const handleLogout = () => {
    logout();
    setMenuOpen(false);
    navigate('/');
  };

  const closeMenu = () => setMenuOpen(false);

  return (
    <nav className="navbar">
      {/* LEFT: Logo */}
      <div className="logo">
        <img src="/images/reach.png" alt="REACH Logo" />
        <span>REACH AI</span>
      </div>

      {/* CENTER/RIGHT: Breadcrumb on /chat (mobile only) */}
      {isChatPage && isMobile ? (
        <div className="breadcrumb" title={user?.location || 'Chatbot'}>
          Chatbot
          {user?.location && <span> • {user.location}</span>}
        </div>
      ) : null}

      {/* RIGHT: Hamburger (mobile only) */}
      <button
        className="menu-toggle"
        aria-label={menuOpen ? 'Close menu' : 'Open menu'}
        aria-expanded={menuOpen}
        onClick={() => setMenuOpen(prev => !prev)}
      >
        {menuOpen ? '✕' : '☰'}
      </button>

      {/* DROPDOWN / DESKTOP NAV */}
      <ul className={`nav-links ${menuOpen ? 'open' : ''}`}>
          <li>
          <Link to="/epics">EPICS-IEEE in Barjalenga</Link>
          </li>

        <li>
          <Link to="/chat" onClick={closeMenu}>Chatbot</Link>
        </li>
        <li>
          <Link to="/" onClick={closeMenu}>Home</Link>
        </li>
        <li>
          <Link to="/about" onClick={closeMenu}>About</Link>
        </li>
        <li>
          <Link to="/contact" onClick={closeMenu}>Contact</Link>
        </li>

        {isAuthenticated ? (
          <>
            <li className="nav-username">
              Hello {user?.name}
              {user?.location && (
                <span className="nav-location"> • {user.location}</span>
              )}
            </li>
            <li>
              <button className="logout-btn" onClick={handleLogout}>
                Logout
              </button>
            </li>
          </>
        ) : (
          <>
            <li>
              <Link to="/login" onClick={closeMenu}>Login</Link>
            </li>
            <li>
              <Link to="/register" onClick={closeMenu}>Register</Link>
            </li>
          </>
        )}
      </ul>
    </nav>
  );
}

export default Navbar;
